import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAll } from '../../service/BlogCategoryService';

export default function BlogCategoryList() {
  const {
    setIsLoading,
    setAppError,
    setAppErrorTitle,
    setAppErrorMessage,
    setAppErrorMode,
  } = useGlobalContext();

  const [blogCategorys, setBlogCategorys] = useState([]);
  const [keyword, setKeyword] = useState('');

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBlogCategoryList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetAll(currentPage, limit, keyword);
      setBlogCategorys(response.blogCategorys || []);
      setTotalPages(response.totalPages || 1); // Ensure backend returns totalPages
      console.log("GetAll returned:", response);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogCategoryList(page);
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchBlogCategoryList(1);
  };

  return (
    <>
      <Helmet>
        <title>Blog Category List | {config.appName} </title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Blog Category List</h1>
            <span>
              <Link to="/"> Dashboard </Link> / Blog Category List
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={handleSearch}
                          >
                            <FontAwesomeIcon icon="fa-solid fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-3 col-sm-6 col-12'>
                      <div className="p-2">
                        <div className="input-group p-4">
                          <Link className="btn btn-success" to="/blogCategory/add">
                            <FontAwesomeIcon icon="fa-solid fa-plus" /> Add Blog Category
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Sl.no</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {blogCategorys && blogCategorys.length > 0 ? (
                        blogCategorys.map((blogCategory, index) => (
                          <tr key={blogCategory.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>
                              <img
                                src={`${config.imageBasePath}/blogCategory/${blogCategory.id}.${blogCategory.image}`}
                                alt={blogCategory.name}
                                className='img-fluid image-xs'
                              />
                            </td>
                            <td>{blogCategory.name}</td>
                            <td>{blogCategory.status}</td>
                            <td>
                              <Link
                                to={`/blogCategory/edit/${blogCategory.id}`}
                                className='btn btn-sm btn-primary'
                                title="Edit Blog Category"
                              >
                                <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">No Blog Categories found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
